export default "__VITE_ASSET__43f09042__"